<template>
  <div ref="pageView" class="page-view container-view pd-lr-20">
    <!-- title -->
    <section class="title-section fixed-view">
      <e6-title
        >对接日志
        <template slot="operate">
          <el-button
            class="g-form-section-search operate__item oper-btn"
            icon="e6-icon-export_line"
            title="导出"
            v-if="operationSuper.导出"
            @click="handleExport"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': !isSearch }"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" :hidden="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @submitForm="handlesSubmitForm"
      >
        <template slot-scope="slotForms">
          <el-form-item prop="forms.timeRange" class="date-time">
            <el-date-picker
              v-model="slotForms.forms.timeRange"
              type="datetimerange"
              unlink-panels
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :default-time="['00:00:00', '23:59:59']"
              :picker-options="datePickerOptions"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item prop="forms.serviceIdList" class="form-item_2">
            <el-select
              v-model="slotForms.forms.serviceIdList"
              multiple
              filterable
              collapse-tags
              reserve-keyword
              placeholder="服务商名称"
              :loading="loading"
            >
              <el-option
                v-for="item in auditProviderList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="forms.comparyIdList" class="form-item_2">
            <el-select
              v-model="slotForms.forms.comparyIdList"
              multiple
              filterable
              collapse-tags
              reserve-keyword
              placeholder="企业名称"
              :loading="loading"
            >
              <el-option
                v-for="item in auditComparysList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="forms.operateSecondModule">
            <el-select
              v-model="slotForms.forms.operateSecondModule"
              placeholder="操作模块"
              clearable
            >
              <el-option label="服务商基础信息" :value="15"></el-option>
              <el-option label="企业信息接入" :value="1001"></el-option>
              <el-option label="冷库信息接入" :value="1002"></el-option>
              <el-option label="区位信息接入" :value="1003"></el-option>
              <el-option label="区位监测点信息接入" :value="1004"></el-option>
              <el-option label="门店信息接入" :value="1005"></el-option>
              <el-option label="冷柜信息接入" :value="1006"></el-option>
              <el-option label="冷柜监测点信息接入" :value="1007"></el-option>
              <el-option label="车辆信息接入" :value="1008"></el-option>
            </el-select>
          </el-form-item>
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->

    <!-- 表格 -->
    <section class="table-section" :style="{ height: resizeViewHeight + 'px' }">
      <el-table
        v-loading="tableLoading"
        element-loading-text="拼命加载中"
        ref="multipleTable"
        border
        :data="tableData"
        height="100%"
      >
        <el-table-column
          header-align="center"
          show-overflow-tooltip
          align="center"
          fixed="left"
          type="index"
          label="序号"
          width="55"
        ></el-table-column>
        <el-table-column
          header-align="center"
          show-overflow-tooltip
          fixed="left"
          align="left"
          label="IP"
          min-width="140"
          prop="ipAddress"
        ></el-table-column>
        <el-table-column
          header-align="center"
          show-overflow-tooltip
          align="left"
          label="操作服务商"
          min-width="140"
          prop="serviceProviderName"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          show-overflow-tooltip
          align="left"
          label="操作企业"
          min-width="140"
          prop="companyName"
        ></el-table-column>
        <el-table-column
          header-align="center"
          show-overflow-tooltip
          align="left"
          label="操作模块"
          min-width="150"
          prop="operateModuleStr"
        ></el-table-column>
        <el-table-column
          header-align="center"
          show-overflow-tooltip
          align="left"
          label="操作内容"
          min-width="350"
          prop="operateContent"
        ></el-table-column>
        <el-table-column
          header-align="center"
          show-overflow-tooltip
          align="center"
          label="操作时间"
          min-width="150"
          prop="operateTime"
        ></el-table-column>
      </el-table>
    </section>
    <!-- 表格 end -->
    <!-- 翻页 -->
    <section class="pagination-section fixed-view">
      <e6-pagination
        :total="total"
        :pageSize.sync="formExtend.forms.pageParamVO.pageSize"
        :currentPage.sync="formExtend.forms.pageParamVO.curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import resizeListener from "_private/mixins/resizeListener";
import auditManage from "@/mixins/auditManage";

import { datePickerOptionsNotContainToday } from "@/utils/dateUtil.js";
import { findByPage } from "@/api/buttJointCenter/journal.js";
import operationManage from "_private/mixins/operationManage";

import moment from "moment";
export default {
  mixins: [resizeListener, auditManage, operationManage],
  data() {
    return {
      tableLoading: false,
      loading: false,
      isSearch: false,
      total: 0,
      timeData: [],
      formExtend: {
        forms: {
          timeRange: [
            moment()
              .startOf("day")
              .subtract(7, "days")
              .valueOf(),
            moment()
              .endOf("day")
              .valueOf()
          ],
          operateTimeParamStart: "", // 开始时间
          operateTimeParamEnd: "", // 结束时间
          comparyIdList: [], // 企业名称
          serviceIdList: [], // 服务商名称
          operateSecondModule: "", // 操作模块
          pageParamVO: {
            curPage: 1,
            pageSize: 20
          }
        },
        extends: []
      },
      tableData: [],
      datePickerOptions: datePickerOptionsNotContainToday
    };
  },
  computed: {
    ...mapGetters(["moduleId", "userId", "searchFormIsOpen"])
  },
  created() {
    this.getAuditComparys();
    this.getAuditProvider();
    this.init();
  },
  methods: {
    // 初始化界面信息
    init() {
      if (!this.formExtend.forms.timeRange) {
        this.$message.warning("请选择开始时间与结束时间");
        return;
      }
      this.tableLoading = true;
      let param = JSON.parse(JSON.stringify(this.formExtend.forms));
      param.operateTimeParamStart = moment(
        this.formExtend.forms.timeRange[0]
      ).valueOf();
      param.operateTimeParamEnd = moment(
        this.formExtend.forms.timeRange[1]
      ).valueOf();
      delete param.timeRange;
      findByPage(param)
        .then(res => {
          let tableData = [];
          let total = 0;
          if (res.code === 1 && res.result) {
            total = res.result.totalRecords;
            tableData = res.result.data;
          }
          this.tableData = tableData;
          this.total = total;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    // 是否查询
    handleIsSearch() {
      this.isSearch = !this.isSearch;
      this.$nextTick(() => {
        this.resizeListener();
      });
    },
    // 翻页
    handleCurrentChange(e) {
      this.formExtend.forms.pageParamVO.curPage = e;
      this.init();
    },
    // 设置每页多少条
    handleSizeChange(e) {
      this.formExtend.forms.pageParamVO.pageSize = e;
      this.init();
    },
    //点击查询
    handlesSubmitForm() {
      this.formExtend.forms.pageParamVO.curPage = 1;
      this.init();
    },
    // 导出列表数据
    handleExport() {
      if (!this.formExtend.forms.timeRange) {
        this.$message.warning("请选择开始时间与结束时间");
        return;
      }
      let param = JSON.parse(JSON.stringify(this.formExtend.forms));
      param.operateTimeParamStart = moment(
        this.formExtend.forms.timeRange[0]
      ).valueOf();
      param.operateTimeParamEnd = moment(
        this.formExtend.forms.timeRange[1]
      ).valueOf();
      let url = "/docking/dockingLog/exportDockingLog";
      let params =
        "?serviceIdList=" +
        param.serviceIdList +
        "&comparyIdList=" +
        param.comparyIdList +
        "&operateSecondModule=" +
        param.operateSecondModule +
        "&operateTimeParamStart=" +
        param.operateTimeParamStart +
        "&operateTimeParamEnd=" +
        param.operateTimeParamEnd;
      document.location.href = url + params;
    },
    // 跳转对应详情页面
    jumpDetail(num) {
      if (num < 1) {
        return;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}
.title-section {
  padding: 15px 0 10px;
}
.form-section {
  .form-extend {
    .form-item_2 {
      width: 200px;
      /deep/.el-form-item--mini .el-form-item__content {
        width: 200px;
      }
      /deep/.el-select {
        width: 200px;
        .el-select__tags {
          max-width: 195px !important;
        }
        .el-select__tags-text {
          display: inline-block;
          max-width: 90px;
          text-overflow: ellipsis;
          overflow: hidden;
          vertical-align: middle;
        }
      }
    }
  }
}

.table-section {
  height: 200px;
}

.pagination-section {
  padding: 10px 0;
}

.batch-delete {
  line-height: 100px;
  text-align: center;
  background-color: #fff;
}
// 是否跳转
.is-jump {
  cursor: pointer;
  color: #5975e3;
}
</style>
<style lang="scss">
.el-tooltip__popper.is-dark {
  max-width: 900px;
}
</style>
